/**
 * Uppercase the first letter of the string and replace the dashes with spaces.
 *
 */
export const titleCase = (text: string): string => {
  return text
    .split('-')
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word,
    )
    .join(' ')
}
